import React from 'react';

import { BoldText } from './AdditionalInfo.styled';
import { ContactPatientNavigatorLink } from 'screens/Book/components/ContactPatientNavigatorLink';
import { MemberServicesPhoneLink } from 'screens/Book/components/MemberServicesPhoneLink';

import { AdditionalInfoProps } from './AdditionalInfo.types';
import { AdditionalInfoProviderSearch } from './AdditionalInfoProviderSearch';
import { AdditionalInfoVirtual } from './AdditionalInfoVirtual';
import { AdditionalInfoWalmart } from './AdditionalInfoWalmart';

export const AdditionalInfo = (props: AdditionalInfoProps): JSX.Element => {
  if (props.isWalmartPatient) return <AdditionalInfoWalmart />;
  if (props.requiresPointerToDoctorPages) {
    return (
      <AdditionalInfoProviderSearch
        phone={props.phone}
        hideInPersonOption={props.hideInPersonOption}
      />
    );
  }
  if (props.isVirtual) return <AdditionalInfoVirtual phone={props.phone} />;

  return (
    <>
      <BoldText>
        Do you need more immediate scheduling or need help booking with a specific provider?
      </BoldText>
      <br />
      <ContactPatientNavigatorLink /> or call <MemberServicesPhoneLink phone={props.phone} />
    </>
  );
};
